<style scoped>
input[type="text"],
input[type="number"],
input[type="email"] {
  width: 100%;
  height: 40px;
  border: none;
  outline: 0;
  border-radius: 5px;
  border: 1px solid #cbced4;
  box-sizing: border-box;
  padding: 0px 10px;
  background-color: initial;
}
.input-div span {
  position: absolute;
  top: 10px;
  left: 22px;
  font-size: 14px;
  transition: all 0.5s;
}
.input-div input:focus ~ span,
.input-div input:valid ~ span {
  top: -15px;
  left: 18px;
  font-size: 10px;
  font-weight: 600;
}
.warning {
  border: 1px solid red !important;
}
</style>

<template>
  <div :class="'input-div mb-4' + inputClass">
    <input :type="type" :name="name" require required />
    <span>{{ title }}</span>
  </div>
</template>
<script>
export default {
  props: {
    title: "",
    type: "text",
    inputClass: "",
    name: "",
  },
};
</script>
